(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/kyc/kyc.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/kyc/kyc.js');
'use strict';

const {
  useRef,
  useEffect,
  useState
} = React;
const {
  useHistory
} = ReactRouterDOM;
const {
  routes
} = svs.myProfile.constants;
const {
  Skeleton
} = svs.myProfile.react.shared.components;
const {
  ReactIcon
} = svs.ui;
const {
  defaultTechnicalErrorDialog
} = svs.myProfile.react.pages.kyc.dialogs;
const Kyc = () => {
  const [isKycLoaded, setIsKycLoaded] = useState(false);
  const kycContainerRef = useRef();
  const history = useHistory();
  const kycErrorCallback = async () => {
    await defaultTechnicalErrorDialog();
  };
  useEffect(() => {
    const onKycCancel = () => {
      history.push(routes.MY_PROFILE_HOME);
    };
    const navigateToQuestions = () => {
      history.push(routes.MY_PROFILE_KYC_QUESTIONS);
    };
    svs.core.module.load('/cl/components/react:kyc', null, () => {
      setIsKycLoaded(true);
      svs.components.kyc.init(kycContainerRef.current, {
        context: void 0,
        onComplete: navigateToQuestions,
        showOverview: true,
        onCancel: onKycCancel,
        onError: kycErrorCallback
      });
    }, false);
    svs.core.module.load('/cl/components/kyc-messages', null, () => {
      svs.components.kyc_messages.showKYCMessage();
    });
  }, [history]);
  return React.createElement("section", {
    className: "margin-bottom-4"
  }, React.createElement("div", {
    className: "align-center padding-top-2 padding-bottom-1 margin-bottom"
  }, React.createElement(ReactIcon, {
    icon: "money-laundry",
    size: "900"
  })), React.createElement("h2", {
    className: "h2 margin-bottom-1 align-center"
  }, React.createElement("span", {
    className: "f-medium"
  }, "Dina svar bidrar till en trygg spelmarknad")), !isKycLoaded && React.createElement(React.Fragment, null, React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 11,
    boxWidthProcent: 100,
    topMargin: 3
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  })), React.createElement("div", {
    className: "padding-top-2",
    ref: kycContainerRef
  }));
};
svs.myProfile.react.pages.kyc.Kyc = Kyc;

 })(window);